import ViewRrhhTravels from '@/requests/travels/rrhh/listRequestRrhh'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute(
  '/_authenticated/requests/viewTravel/listRequestRrhh',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' })
    }


    const { isAdmin, isRRHH, isSupervisor } = context.userRoles

    if (!isAdmin && !isRRHH && !isSupervisor) {
      throw redirect({ to: '/unauthorized' })
    }
  },

  component: ViewRrhhTravels,

  validateSearch: z.object({
    travelId: z.string().optional(),
  }),
})